import React, { ReactNode } from 'react'

import QuestionIcon from 'app/assets/icons/auth/question-mark.svg'
import Box from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import Tooltip from 'app/components/base/Tooltip'
import useAppStore from 'app/store/app.store'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface WithTooltipContainerProps {
  tooltipContent: string | ReactNode
}

const WithTooltipContainer: RFC<WithTooltipContainerProps> = ({
  tooltipContent,
  children
}) => {
  const isTablet = useAppStore((state) => state.isTablet)

  return (
    <Stack
      direction="row"
      sx={{ position: 'relative', alignItems: 'flex-start', flex: 1 }}
      {...(!IS_NATIVE_APP && { spacing: 1 })}
    >
      {children}

      <Box
        sx={{
          position: { xs: 'relative', md: isTablet ? 'relative' : 'absolute' },
          right: { md: isTablet ? 0 : -32 },
          pt: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px'
        }}
      >
        <Tooltip
          placement="bottom"
          isCloseButton
          content={
            <Text
              variant="subtitle1"
              color="common.white"
              {...(IS_NATIVE_APP && { sx: { maxWidth: 242 } })}
            >
              {tooltipContent}
            </Text>
          }
        >
          <IconButton>
            <QuestionIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  )
}

export default WithTooltipContainer
